import { connect } from 'react-redux'
import MapView from '../../components/MapView'
import {
  ICoordinatesWithShortKeyDTO,
  IGetGoogleMapPolyline,
  IMapBound,
  IMarker,
  IOSMDirectionReq,
  IStoreState
} from '../../types'
import { SET_DESTINATION_TO_TRIP_REQUEST, SET_ORIGIN_TO_TRIP_REQUEST } from '../../state/constants'
import { getOSMDirection, getDirections, actionCreators as mapActionCreators } from '../../state/actions/google_map'
import { selectPinLocation } from '../../state/actions/trips'

function mapStateToProps(state: IStoreState, ownProps: any) {
  const { isDraggable, renderStrategy } = ownProps

  const {
    goinzones: { items },
    mapView: {
      bounds,
      center,
      destination,
      markers: stateMarkers,
      origin,
      polygon,
      polyline,
      renderStrategyStage,
      zoom,
      zoneId
    },
    trips: { currentTripId, currentTripState: tripState, items: tripItems }
  } = state

  const zone = zoneId ? items[zoneId] : null
  let markers: IMarker[] = []
  Object.values(stateMarkers).forEach(markerList => {
    markers = markers.concat(markerList)
  })

  const waypoints =
    markers.length > 0
      ? markers
          .filter(marker => marker.type === 'additionalStop')
          .map(marker => {
            const { lat, lng } = marker
            return {
              location: new google.maps.LatLng(lat, lng),
              stopover: true
            }
          })
      : null

  return {
    bounds,
    center,
    currentTrip: tripItems[currentTripId],
    destination,
    isDraggable,
    markers,
    origin,
    polygon,
    polyline,
    renderStrategyStage: renderStrategy || renderStrategyStage,
    tripState,
    waypoints: waypoints !== null && waypoints.length > 0 ? waypoints : null,
    zone,
    zoneId,
    zones: items,
    zoom
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    getDirections: (dto: IGetGoogleMapPolyline) => dispatch(getDirections(dto)),
    selectPickup: (locationInfo: ICoordinatesWithShortKeyDTO) =>
      dispatch(selectPinLocation(locationInfo, SET_ORIGIN_TO_TRIP_REQUEST)),
    selectDropoff: (locationInfo: ICoordinatesWithShortKeyDTO) =>
      dispatch(selectPinLocation(locationInfo, SET_DESTINATION_TO_TRIP_REQUEST)),
    setPolyline: (routePolyline: string) => dispatch(mapActionCreators.setPolyline(routePolyline)),
    setBounds: (bounds: IMapBound) => dispatch(mapActionCreators.setBounds(bounds)),
    getOSMDirection: (dto: IOSMDirectionReq) => dispatch(getOSMDirection(dto))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapView)



// WEBPACK FOOTER //
// ./src/containers/googleMap/GoogleMaps.ts